











import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CustomButton extends Vue {
  @Prop() private text!: string;
  @Prop({
    default: 'plus'
  })
  private icon!: string;
  @Prop() private handleClick!: any;
}
